// extracted by mini-css-extract-plugin
export default {"Wrapper":"Icon_Wrapper__y1eNS","SvgPractice":"Icon_SvgPractice__tOXR5"};